/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { useNavigate } from 'react-router-dom';
import { Typography, useTheme } from '@mui/material';

export const PrimaryLink = ({ children, to, sx }: any) => {
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <Typography
      variant="body2"
      component="label"
      sx={{ ...sx, cursor: 'pointer', color: theme.palette.text.primary }}
      onClick={() => navigate(to)}
    >
      {children}
    </Typography>
  );
};

export const SecondaryLink = ({ children, to, sx }: any) => {
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <Typography
      variant="body2"
      component="label"
      sx={{ ...sx, cursor: 'pointer', color: theme.palette.text.secondary }}
      onClick={() => navigate(to)}
    >
      {children}
    </Typography>
  );
};

export const NormalTextLink = ({ children, to, sx }: any) => {
  const navigate = useNavigate();
  return (
    <Typography
      variant="body2"
      component="label"
      sx={{ ...sx, cursor: 'pointer' }}
      onClick={() => navigate(to)}
    >
      {children}
    </Typography>
  );
};
